<template>
  <span>
    <slot name="button" v-bind="{onclick: toggle}">
      <b-button variant="primary" class="mr-1" size="xs" @click="toggle"><i class="fas fa-edit"></i>&nbsp;Edit</b-button>
    </slot>

    <b-modal
        @show="onShow"
        @shown="onShown"
        @hidden="resetModal"
        ref="modal-container"
        v-model="modalShow"
        size="lg"
        :title="title"
        :static="true"
        :lazy="true"
        hide-footer
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">


        <b-form-group  label="ID" label-for="id-input">
           <b-form-input id="id-input"
                         v-model="formValues.id"
                         autocomplete="off"
                         :disabled="!this.create"
           />
        </b-form-group>

        <b-form-group label="Name" label-for="name-input">
         <b-form-input id="name-input"
                       v-model="formValues.name"
                       v-validate="{ required: true }"
                       :state="validateState('name-input')"
                       aria-describedby="name-input-live-feedback"
                       data-vv-name="name-input"
                       data-vv-as="Name"
                       autocomplete="off"
         />
          <b-form-invalid-feedback id="name-input-live-feedback">
            {{ veeErrors.first('name-input') }}
          </b-form-invalid-feedback>
        </b-form-group>
      </form>

      <b-button class="mt-2 float-right" variant="primary" @click="handleSubmit">Save</b-button>
    </b-modal>
  </span>
</template>
<script>
import Vue from "vue";

export default {
  data() {
    return {
      modalShow: false,
      formValues: this.getInitialValues(),
    }
  },
  components: {
  },
  props: {
    create: Boolean,
    title: String,
    defaultValues: Object
  },
  methods: {
    validateState(ref) {
      if (
          this.veeFields[ref] &&
          (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    getInitialValues() {
      return {
        id: null,
        name: null
      }
    },
    onShow() {
      this.setDefaults();
    },
    onShown() {
    },
    resetModal() {
      this.setDefaults();
    },
    setDefaults() {
      let initialValues = this.getInitialValues();

      for (let field in initialValues) {
        Vue.set(this.formValues, field, initialValues[field]);
      }

      if (this.defaultValues) {
        for (let field in this.defaultValues) {
          Vue.set(this.formValues, field, this.defaultValues[field]);
        }
      }
    },
    hideModal() {
      this.$refs['modal-container'].hide();
    },
    toggle() {
      this.modalShow = !this.modalShow;
    },
    handleSubmit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }

        this
            .$http({
              url: this.create ? '/api/v1/game-types' : '/api/v1/game-types/' + this.formValues.id,
              method: this.create ? 'POST' : 'PUT',
              data: {
                id: parseInt(this.formValues.id),
                name: this.formValues.name,
              },
            })
            .then(() => {
              setTimeout(() => {
                this.$emit('finish')
              }, 500);

              this.hideModal();
              this.$toastr.i('Success');
            })
            .catch((err) => {
              let message;

              if (typeof err.response.data.message === 'string') {
                message = err.response.data.message;
              } else {
                message = JSON.stringify(err.response.data.message);
              }

              this.$toastr.e(message);

              throw err;
            });
      });
    },
  },
  computed: {
  },
  beforeMount() {
  },
  mounted() {
    this.setDefaults();
  },
}
</script>
